module.exports = __webpack_public_path__ + "img/7f31feb.jpg";